import _ from 'lodash'

const principalHash = function(p) {
	return `${p.type}:${p.id}:${p.fieldId}`
}

const permissionsUtil = {

	/**
	 * Like principals.equals but it accounts for dataset rollup template principals
	 */
	isEqualPrincipal(p1 = {}, p2 = {}) {
		return principalHash(p1) === principalHash(p2)
	},

	/**
	 * Creates the built-in filter for a tree template principal
	 * These are always the first filter (linkGroup=1) and can not be deleted
	 *
	 * @param {String} principal.rollupTreeGroupLabel
	 * @param {Number|String} treeRootId
	 * @param {Number} fieldId
	 *
	 * @returns {DatasetFilter}
	 */
	newBuiltInRollupFilter(principal, treeRootId, fieldId) {
		return _.extend({
			deletable: false,
			treeIds: [treeRootId],
			// This isn't a persistent attribute, but we set it here for now
			// so filter-text.js can read it on non-persisted filters
			// since there is no associated permission in the dataset model
			rollupTreeGroupLabel: principal.rollupTreeGroupLabel
		}, this.newRollupFilter(treeRootId, fieldId))
	},

	/**
	 * Create a new rollup filter
	 *
	 * @param {Number|String} treeRootId
	 * @param {Number} fieldId
	 * @param {Number} [linkGroup=1]
	 *
	 * @returns {DatasetFilter}
	 */
	newRollupFilter(treeRootId, fieldId, linkGroup = 1) {
		const rollupIsAnyFilters = {}
		// The user can change this value in the select for the new principal
		// once it's added to the panel.
		rollupIsAnyFilters[treeRootId] = 'item-rollups-and-descendants'
		return {
			fieldId,
			operator: 'is-any',
			rollupIsAnyFilters,
			linkGroup
		}
	}
}

export default permissionsUtil
permissionsUtil.__filename__ = 'datasets/edit/permissions-util.js'
